import { combineReducers } from '@reduxjs/toolkit';
import payroll from './payrollSlice';
import outstandings from './outstandingsSlice';
import paystubs from './paystubsSlice';

const reducer = combineReducers({
  payroll,
  outstandings,
  paystubs
});

export default reducer;
